module.exports = __webpack_public_path__ + "img/27.43ca321b.gif";